
import Vue from "vue"

export default Vue.extend({
  name: "AlertInfo.vue",
  props: {
    message: String
  }
})
